import { useLocale } from '../stores/userPreferencesStore';

/**
 * Custom hook for currency formatting utilities
 */
export function useCurrency() {
  const locale = useLocale();

  /**
   * Format a number as US currency
   * @param amount - The amount to format
   * @returns Formatted currency string (e.g., "$1,234")
   */
  const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  return { formatCurrency };
}
